var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export var VideoFragment = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment VideoFragment on Video {\n    id\n    vimeoId\n  }\n"], ["\n  fragment VideoFragment on Video {\n    id\n    vimeoId\n  }\n"])));
export default {};
var templateObject_1;
